import { KioskResource } from './KioskResource';

export class TermsOrGdprAndKioskResource {
    rid: number;
	kiosk: KioskResource;
}